import { Box } from '@mui/material';

import './TableTitle.css';

export const TableTitle = ({ children }) => <Box className="table-title">{children}</Box>;

export default TableTitle;
